export default {
  stepContainerBackground: '',
  stepContainerBackgroundAfter: '',
};
